import { useStaticQuery } from 'gatsby';

var useSiteMetadata = function useSiteMetadata() {
  var data = useStaticQuery("873005918");
  return data.site.siteMetadata;
};

export default useSiteMetadata;